<div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between start">
        <div fxLayout="row" style="width: 85px;">Date</div>
        <div fxFlex="10">Invoice</div>
        <div fxFlex="15" fxFlexFill fxLayout="column" fxLayoutAlign="start start">Description</div>
        <div *ngIf="useUnit" class="number-header" fxFlex="5" fxFlexFill fxLayout="row" fxLayoutAlign="end">
            Invoiced<br>Units</div>
        <div class="number-header" fxFlex="10" fxLayout="row" fxLayoutAlign="end">Invoiced<br>Price</div>
        <div *ngIf="useTax" class="number-header" fxFlex="10" fxLayout="row" fxLayoutAlign="end">Invoiced<br>Sales Tax
        </div>
        <div *ngIf="useShipping" class="number-header" fxFlex="10" fxLayout="row" fxLayoutAlign="end">
            Invoiced<br>Shipping</div>
        <div class="number-header" fxFlex="10" fxLayout="row" fxLayoutAlign="end"><strong>Invoiced<br>Total</strong>
        </div>
        <div *ngIf="usePaymentDate" fxFlex="10" fxLayout="row" style="padding-left: 8px;">Payment<br>Date</div>
        <div *ngIf="usePaymentNumber" fxFlex="10" fxLayout="row">Payment<br>Number</div>
    </div>
</div>

<mat-divider></mat-divider>

<div *ngIf="!hasInvoices()" fxLayout="row" fxLayoutAlign="center center">
    No Invoices
</div>

<div *ngIf="hasInvoices()">
    <div *ngFor="let invoice of invoices">
        <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between start">
            <div fxLayout="row" style="width: 85px;">{{invoice.Date}}</div>
            <div fxFlex="10">{{invoice.Number}}</div>
            <div fxFlex="15" fxFlexFill fxLayout="column" fxLayoutAlign="start start">{{invoice.Description}}</div>
            <div *ngIf="useUnit" fxFlex="5" fxLayout="row" fxLayoutAlign="end">{{invoice.Units}}</div>
            <div fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{invoice.Amount | currency}}</div>
            <div *ngIf="useTax" fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{invoice.SalesTax | currency}}</div>
            <div *ngIf="useShipping" fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{invoice.Shipping| currency}}</div>
            <div fxFlex="10" fxLayout="row" fxLayoutAlign="end"><strong>{{invoice.InTotal | currency}}</strong></div>
            <div *ngIf="usePaymentDate" fxFlex="10" fxLayout="row">&nbsp;&nbsp;{{invoice.PaidDate | date:'MM/dd/yyyy' }}
            </div>
            <div *ngIf="usePaymentNumber" fxFlex="10">{{invoice.PaymentNumber}}</div>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between start">
        <div style="width: 85px;"><strong>Totals:</strong></div>
        <div fxFlex="10"></div>
        <div fxFlex="15"></div>
        <div *ngIf="useUnit" fxFlex="5"></div>
        <div fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{total.Amount | currency}}</div>
        <div *ngIf="useTax" fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{total.SalesTax | currency}}</div>
        <div *ngIf="useShipping" fxFlex="10" fxLayout="row" fxLayoutAlign="end">{{total.Shipping| currency}}</div>
        <div fxFlex="10" fxLayout="row" fxLayoutAlign="end"><strong>{{total.InTotal | currency}}</strong></div>
        <div *ngIf="usePaymentDate" fxFlex="10"></div>
        <div *ngIf="usePaymentNumber" fxFlex="10"></div>
    </div>
    <mat-divider></mat-divider>
</div>